<template>
	<div id="matchwinpanel" class="container row text-center">
    <div class="col-md-12 col-lg-6 d-lg-flex flex-lg-column justify-content-center">
      <b>Mumbai Indians been the overall match winner throughout 2008-16</b>
      <p>Over the years, the league has been a spectator to several spectacular innings and terrific bowling spells which changed the tide of the match altogether.
         There have been quite a few players both Indian and Overseas who turned out to be quite the match winners.</p>
    </div>
    <div class="col-md-12 col-lg-6">
      <BarChart
        :data="match_winners"
        :colorScheme="'schemePaired'"
        :yDomain="[85, 0]"
        :height="660"
        :xRange="xRange" />
    </div>
	</div>
</template>

<script>
import match_winners from "../assets/match_winners.json";

export default {
  name: "MatchWinnersPanel",
  components: {
    BarChart: () => import("./BarChart.vue")
  },
  data() {
    return {
      match_winners,
      xRange: [0, 500],
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "orientationchange",
        this.detectOrientationChange
      );
    });
  },
  created() {
    this.detectOrientationChange();
  },
  methods: {
    detectOrientationChange() {
      // switch (window.orientation) {
      //   case 0:
      //     // landscape
      //     this.xRange = [0, 250];
      //     break;
      //   default:
      //     // portrait
      //     this.xRange = [0, 500];
      //     break;
      // }

      if (window.screen.width > 767) {
        this.xRange = [0, 500];
      } else {
        this.xRange = [0, 250];
      }
    }
  }
};
</script>

<style>
#matchwinpanel {
  padding: 20px;
  border-bottom: 1px grey solid;
}
</style>
